import { AbstractControl } from '@angular/forms';
import * as dayjs from 'dayjs';

export function birthdateValidator(control: AbstractControl) {
    let today = dayjs();
    let earliest  = dayjs("1900-01-01");

    if( isNaN(dayjs(control.value).year())) {
        return { "invalidbirthdate": true };
    }
    if( dayjs(control.value).year() < 1900 ){
        return { 'invalidbirthdate': true };
    }
    if ( control.value != null && dayjs(control.value).isValid()
        && dayjs(control.value).isAfter(earliest) &&  dayjs(control.value).isBefore(today)) {
        return null;
    }
    return {'invalidbirthdate': true};
}